<p-table [value]="impacts" [columns]="impactsOnGlColumns" styleClass="p-datatable-gridlines p-datatable-striped">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th *ngFor="let col of columns">{{ col.header }}</th>
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-product let-columns="columns">
        <tr>
            <ng-container *ngFor="let col of columns">
                <td *ngIf="col.dataType == 'date'">
                    {{ product[col.field] | localDate:'MM/DD/YYYY' }}
                </td>
                <td *ngIf="col.dataType == 'number'">
                    {{ product[col.field] | customNumberFormat: fractionDigits | currencySymbol }}
                </td>
                <td *ngIf="col.dataType != 'date' && col.dataType != 'number'">
                    {{ product[col.field] }}
                </td>
            </ng-container>
        </tr>
    </ng-template>

    <ng-template pTemplate="footer" let-rowData let-columns>
        <tr style="position: sticky" class="footer-total">
            <ng-container *ngFor="let col of columns; let i = index">
                <td *ngIf="i < columns.length - 3"></td>
                <td *ngIf="i == columns.length - 3">Total</td>
                <td *ngIf="i == columns.length - 2">
                    {{totalDebit | customNumberFormat: fractionDigits | currencySymbol}}
                </td>
                <td *ngIf="i == columns.length - 1">
                    {{totalCredit | customNumberFormat: fractionDigits | currencySymbol}}
                </td>
            </ng-container>
        </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="8" class="p-text-center">No journal history found</td>
        </tr>
    </ng-template>
</p-table>

